import { Phone, Mail, Clock, MapPin, Facebook } from "lucide-react";
import { FOOTER } from "@/constants/testIds";

const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=100063568961120";

export default function Footer() {
  return (
    <footer className="bg-[#1E293B] text-white border-t-2 border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 sm:py-20">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6">
            <div className="bg-white inline-block p-4 pr-6">
              <img
                src="/img/jjh-logo.png"
                alt="JJH Painting & Pressure Washing LLC"
                className="h-28 sm:h-36 w-auto"
              />
            </div>

            <a
              data-testid={FOOTER.phone}
              href="tel:8505416842"
              className="mt-8 block font-heading font-black uppercase tracking-tighter text-5xl sm:text-7xl leading-none hover:text-[#0EA5E9] transition-colors"
            >
              850-541-6842
            </a>
            <div className="mt-3 text-sm font-semibold uppercase tracking-[0.25em] text-[#94A3B8]">
              Call · Text · Free Estimate
            </div>

            <a
              data-testid="footer-facebook"
              href={FACEBOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="JJH Painting & Pressure Washing on Facebook"
              className="mt-8 inline-flex items-center gap-3 group"
            >
              <span className="h-12 w-12 grid place-items-center bg-[#0EA5E9] group-hover:bg-[#0284C7] transition-colors">
                <Facebook size={22} className="text-white" />
              </span>
              <span className="font-heading font-bold uppercase tracking-wider text-sm sm:text-base text-white group-hover:text-[#0EA5E9] transition-colors">
                Follow Us On Facebook
              </span>
            </a>
          </div>

          <div className="lg:col-span-6 grid sm:grid-cols-2 gap-8">
            <Block icon={Mail} label="Email" testId={FOOTER.email}>
              <a href="mailto:jjhpaintingpw@gmail.com" className="hover:text-[#0EA5E9] break-all">
                jjhpaintingpw@gmail.com
              </a>
            </Block>
            <Block icon={Clock} label="Hours" testId={FOOTER.hours}>
              <div>Mon – Sat</div>
              <div>8:00a – 5:00p</div>
            </Block>
            <Block icon={MapPin} label="Service Area">
              All of Bay County, FL
              <div className="text-[#94A3B8] mt-1">Except Tyndall AFB</div>
            </Block>
            <Block icon={Phone} label="Phone">
              <a href="tel:8505416842" className="hover:text-[#0EA5E9]">850-541-6842</a>
            </Block>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between text-xs uppercase tracking-[0.2em] text-[#64748B]">
          <div>© {new Date().getFullYear()} JJH Painting & Pressure Washing LLC. All rights reserved.</div>
          <div>Bay County · Florida · Licensed &amp; Insured</div>
        </div>
      </div>
    </footer>
  );
}

function Block({ icon: Icon, label, children, testId }) {
  return (
    <div data-testid={testId}>
      <div className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.3em] text-[#0EA5E9]">
        <Icon size={14} />
        {label}
      </div>
      <div className="mt-3 font-heading font-bold uppercase tracking-tight text-white text-lg leading-tight">
        {children}
      </div>
    </div>
  );
}
